// Global copyright footer. Rendered once at the App level so it appears
// consistently on every current and future page without per-page wiring.
export default function Footer() {
  return (
    <footer
      className="w-full border-t border-brand-border bg-transparent"
      data-testid="app-footer"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-5 text-center text-xs tracking-wide text-brand-ink-muted">
        Copyright EWTA 2026
      </div>
    </footer>
  );
}
